import { type TranslationTree } from '@/i18n/types';

export const messages = {
  displayNameRequired: 'O nome público é obrigatório',
  displayNameShort: 'O nome público precisa de pelo menos 2 caracteres',
  legalNameRequired: 'A razão social ou o nome completo é obrigatório',
  legalNameShort: 'A razão social precisa de pelo menos 2 caracteres',
  taxIdRequired: 'O CPF ou CNPJ é obrigatório',
  taxIdInvalid: 'Digite um CPF ou CNPJ válido',
  categoryRequired: 'Selecione o tipo de parceiro',
  contactNameRequired: 'O nome do contato é obrigatório',
  contactEmailRequired: 'O e-mail de contato é obrigatório',
  contactEmailInvalid: 'Digite um e-mail válido',
  phoneInvalid: 'Digite um telefone com DDD',
  stateInvalid: 'Selecione uma UF válida',
  websiteInvalid: 'Digite um endereço que comece com https://',
  instagramInvalid: 'Digite um perfil do Instagram válido',
  termsRequired: 'É preciso aceitar os termos de parceiro',
  tooLong: 'Texto acima do limite de caracteres',
} satisfies TranslationTree;
